module.exports={
    // base_url:"http://wellworld.id:19870"
 // base_url:"http://intellivent.id:19871"
   base_url:"https://sinara-api.narabahasa.id",
  //  base_url:"https://sinara-api.intellivent.id",
    // base_url:"https://sinara-api.intellivent.id"
    //  base_url:"https://sinara-api-2.narabahasa.id",
};
